import { useEffect, useRef, useState } from "react";
import { useLocation } from "wouter";

/**
 * A thin blue line that runs across the top of the screen each time the
 * visitor moves to another page. Not shown on the first page load.
 */
export function RouteProgress() {
  const [location] = useLocation();
  const previous = useRef(location);
  const [run, setRun] = useState(0);

  useEffect(() => {
    if (location === previous.current) return;
    previous.current = location;
    setRun((n) => n + 1);
  }, [location]);

  if (run === 0) return null;
  // A new key restarts the CSS animation on every navigation.
  return (
    <div
      key={run}
      aria-hidden="true"
      className="route-progress fixed top-0 left-0 right-0 z-[60] h-[3px] origin-left bg-accent shadow-[0_0_8px_hsl(var(--accent))] pointer-events-none"
    />
  );
}
